import React from "react";
import { Route, Switch } from "react-router-dom";

import { ThemeProvider } from "@mui/material/styles";
import TMSTheme from "../../../themes/TMSTheme";

import Dashboard from "./Dashboard";
import Library from "./Library/Library";
import Category from "./Library/Category";
import Course from "./Course/Course";
import CourseList from "./Course/CourseList";
import EventList from "./Event/EventList";
import Event from "./Event/Event";
import Module from "./Module/Module";
import MyEnrolments from "./Enrolment/MyEnrolments";
import MyAccomplishments from "./Accomplishment/MyAccomplishments";
import Accomplishment from "./Accomplishment/Accomplishment";

const CTMSRouter = () => (
    <ThemeProvider theme={TMSTheme}>
        <Switch>
            <Route path="/tms/enrolments" component={MyEnrolments} />
            <Route path="/tms/accomplishment/:id" component={Accomplishment} />
            <Route path="/tms/accomplishments" component={MyAccomplishments} />
            <Route path="/tms/module" component={Module} />
            <Route path="/tms/courses/:id" component={Course} />
            <Route path="/tms/courses" component={CourseList} />
            <Route path="/tms/library/:id" component={Category} />
            <Route path="/tms/library" component={Library} />
            <Route path="/tms/events/:id" component={Event} />
            <Route path="/tms/events" component={EventList} />
            <Route path="/tms/" component={Dashboard} />
        </Switch>
    </ThemeProvider>
);

export default CTMSRouter;
